export {
    IconEfficiency,
    IconEmpathy,
    IconOwnership,
    IconPositivity,
    IconTrust,
} from './icons';
